import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import TruncatedCell from 'components/partials/table-component/truncated-cell/truncated-cell';

import type { AidModelDto } from 'api/generated/schemas/aidModelDto';

const ModelNameCell = ({
  model,
  detailsPath,
}: {
  model: AidModelDto;
  detailsPath: string;
}) => (
  <div className="flex flex-col min-w-0 py-1">
    <RouterLink
      to={detailsPath}
      className="min-w-0 hover:underline"
      data-testid="aid-model-name-link"
    >
      <TruncatedCell value={model.name ?? ''} />
    </RouterLink>
    {model.isOriginal && (
      <span
        className="text-sm font-normal text-gray-500"
        data-testid="original-model-flag"
      >
        Original
      </span>
    )}
  </div>
);

export default ModelNameCell;
